import {inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {ListRequest} from '../../../interfaces/list-request.interface';
import {SearchApiClient} from '../data-access/search-api-client';
import {SearchResponse} from '../interface/search.interface';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchApiCient = inject(SearchApiClient);

  public search(listRequest: ListRequest): Observable<SearchResponse> {
    return this.searchApiCient.getAllSearchedOrders(listRequest);
  }
}
